<template>
  <div class="speedDetails" v-loading.fullscreen.lock="loading">
    <div class="speedDetails_Breadcrumb">
      <Breadcrumb separator=">">
        <span style="padding:0 10px 0 0">当前位置:&nbsp;&nbsp;</span>
        <BreadcrumbItem to="/home">首页</BreadcrumbItem>
        <BreadcrumbItem :to="{name:'speedQuery',params:{code:code}}">进度查询</BreadcrumbItem>
        <BreadcrumbItem>详细信息</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <div class="speedDetails_list">
      <div class="speedDetails_listItem">
        <div class="speedDetails_header">考生基本信息 <strong style="margin-left: 15px">考生类型:</strong><span style="margin-left: 10px">师承出师</span></div>
        <div class="speedDetails_new">
          <div class="speedDetails_new_item">
            <div class="speedDetails_new_cont">
              <strong>姓名:</strong>
              <span>{{userObj.name}}</span>
            </div>
            <div class="speedDetails_new_cont">
              <strong>出生日期:</strong>
              <span>{{userObj.birthday}}</span>
            </div>
            <div class="speedDetails_new_cont">
              <strong>{{identity_type===3?'跟师学习':'参加工作'}}时间:</strong>
              <span>{{userObj.studyTime}}</span>
            </div>
            <div class="speedDetails_new_cont">
              <strong>学历:</strong>
              <span>{{userObj.edu}}</span>
            </div>
            <div class="speedDetails_new_cont">
              <strong>单位名称:</strong>
              <span>{{userObj.unitName}}</span>
            </div>
            <div class="speedDetails_new_cont">
              <strong>本人档案存放单位:</strong>
              <span>{{userObj.archivesCompany}}</span>
            </div>
          </div>
          <div class="speedDetails_new_item">
            <div class="speedDetails_new_cont">
              <strong>性别:</strong>
              <span>{{userObj.gender==1?'男':'女'}}</span>
            </div>
            <div class="speedDetails_new_cont">
              <strong>考核申报地区:</strong>
              <div class="fileTxt" :title="userObj.region">{{userObj.region}}</div>
            </div>
            <div class="speedDetails_new_cont">
              <strong>现从事执业:</strong>
              <div class="fileTxt" :title="userObj.practice">{{userObj.practice}}</div>
            </div>
            <div class="speedDetails_new_cont">
              <strong>学位:</strong>
              <div class="fileTxt" :title="userObj.academic">{{userObj.academic}}</div>
            </div>
            <div class="speedDetails_new_cont">
              <strong>通讯地址:</strong>
              <div class="fileTxt" :title="userObj.postalAddress">{{userObj.postalAddress}}</div>
            </div>
            <div class="speedDetails_new_cont">
              <strong>地址:</strong>
              <div class="fileTxt" :title="userObj.address">{{userObj.address}}</div>
            </div>
          </div>
          <div class="speedDetails_new_item">
            <div class="speedDetails_new_cont">
              <strong>民族:</strong>
              <span>{{userObj.nation}}</span>
            </div>
            <div class="speedDetails_new_cont">
              <strong>户籍所在地:</strong>
              <span>{{userObj.household}}</span>
            </div>
            <div class="speedDetails_new_cont">
              <strong>证件照:</strong>
              <div class="fileTxt" v-if="zjzFile.file_name!=''">
                <img src="@/assets/image/file.png" />
                <a :href="fileUrl+zjzFile.full_path" target="_blank" :title="zjzFile.file_name">{{zjzFile.file_name}}</a>
              </div>
            </div>
            <div class="speedDetails_new_cont">
              <strong>身份证号码:</strong>
              <span>{{userObj.idCarNum}}</span>
            </div>
            <div class="speedDetails_new_cont">
              <strong>单位邮政编码:</strong>
              <span>{{userObj.unitPostalCode}}</span>
            </div>
            <div class="speedDetails_new_cont">
              <strong>邮政编码:</strong>
              <span>{{userObj.PostalCode}}</span>
            </div>
          </div>
        </div>
        <div class="speedDetails_new" v-if="identity_type === 4">
          <div class="speedDetails_new_item">
            <div class="speedDetails_new_cont">
              <strong>本人技术专长述评:</strong>
              <span>{{userObj.review}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="speedDetails_listItem">
        <div class="speedDetails_header" style="padding-top:10px">个人简历</div>
        <div class="speedDetails_Filelist" v-for="item in resumeList" :key="item.id">
          <div class="speedDetails_new" style="padding-bottom:5px">
            <div class="speedDetails_new_item">
              <div class="speedDetails_new_cont">
                <strong>起止年月:</strong>
                <span>{{item.start_date+' ~ '+item.end_date}}</span>
              </div>
            </div>
            <div class="speedDetails_new_item">
              <div class="speedDetails_new_cont">
                <strong>学习(工作)单位:</strong>
                <span>{{item.study_company}}</span>
              </div>
            </div>
            <div class="speedDetails_new_item">
              <div class="speedDetails_new_cont">
                <strong>肄(毕、结)业:</strong>
                <span>{{item.study_type}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="speedDetails_listItem">
        <div class="speedDetails_header" style="padding-top:10px">{{identity_type === 3? "指导老师":(identity_type === 4?"推荐医师":"")}}</div>
        <div class="speedDetails_Filelist" v-for="item in TeacherList" :key="item.id">
          <div class="speedDetails_new" style="padding-bottom:5px">
            <div class="speedDetails_new_item">
              <div class="speedDetails_new_cont">
                <label>指导老师姓名:</label>
                <span>{{item.name}}</span>
              </div>
              <div class="speedDetails_new_cont">
                <label>指导老师职务:</label>
                <span>{{item.title}}</span>
              </div>
              <div class="speedDetails_new_cont">
                <label>指导老师电话:</label>
                <span>{{item.phone}}</span>
              </div>
              <div class="speedDetails_new_cont">
                <label>指导老师医师资格证书编号:</label>
                <span>{{item.yszg_no}}</span>
              </div>
            </div>
            <div class="speedDetails_new_item">
              <div class="speedDetails_new_cont">
                <label>指导老师单位:</label>
                <span>{{item.company}}</span>
              </div>
              <div class="speedDetails_new_cont">
                <label>指导老师工作年限:</label>
                <span>{{item.work_year}}</span>
              </div>
              <div class="speedDetails_new_cont">
                <label>指导老师通讯地址:</label>
                <span>{{item.address}}</span>
              </div>
              <div class="speedDetails_new_cont">
                <label>指导老师身份证号码:</label>
                <span>{{item.idcard_no}}</span>
              </div>
            </div>
          </div>
          <div class="speedDetails_new" style="padding-bottom:5px" v-if="identity_type===4">
            <div class="speedDetails_new_item">
              <div class="speedDetails_new_cont">
                <label>指导老师主要学术思想、临床经验和学术专长:</label>
                <span>{{item.thought}}</span>
              </div>
            </div>
          </div>
          <div class="speedDetails_new_file">
            <div class="speedDetails_new_fileItem" v-for="items in item.fileList" :key="items.id">
              <div class="lable">
                <span>{{items.type_value}}:</span>
              </div>
              <div class="fileTxt">
                <img src="@/assets/image/file.png" />
                <a :href="fileUrl+items.full_path" target="_blank" :title="items.file_name">{{items.file_name}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="speedDetails_listItem">
        <div class="speedDetails_header">资格材料上传</div>
        <div class="speedDetails_new_file">
          <div class="speedDetails_new_fileItem1" v-for="item in zgclFileArr" :key="item.id">
            <div class="lable">
              <span>{{item.type_value}}</span>:
            </div>
            <div class="fileTxt">
              <img src="@/assets/image/file.png" />
              <a :href="fileUrl+item.full_path" target="_blank" :title="item.file_name">{{item.file_name}}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="speedDetails_btn">
        <span v-if="submitState==1 && (cur_audit_status==0 || cur_audit_status == -1)">信息申报有误?</span>
        <Button
          ghost
          style="margin-left:10px"
          @click="withdraw"
          v-if="submitState==1 &&  cur_audit_org_lv==3&&(cur_audit_status==0 || cur_audit_status == 3)"
        >撤回修改</Button>
        <Button ghost style="margin-left:10px" :to="{name:'speedQuery',params:{code:code}}">返回</Button>
      </div>
    </div>
  </div>
</template>
<style lang="less">
.speedDetails {
  width: 1200px;
  margin: 0 auto;
  .speedDetails_Breadcrumb {
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid #ddd;
  }
  .speedDetails_list {
    margin-top: 30px;
    background: #fff;
    padding: 15px;
    box-sizing: border-box;
    .speedDetails_header {
      height: 35px;
      border-bottom: 1px solid #ddd;
      font-size: 13px;
      font-weight: bold;
    }
    .speedDetails_new {
      padding: 20px 0 0;
      display: flex;
      .speedDetails_new_item {
        flex: 1;
      }
      .speedDetails_new_cont {
        height: 40px;
        label {
          float: left;
          width: 285px;
          height: 40px;
          line-height: 40px;
          color: #666666;
          font-size: 14px;
          font-weight: bolder;
          text-align: right;
        }
        strong {
          float: left;
          width: 140px;
          height: 40px;
          line-height: 40px;
          color: #666666;
          font-size: 14px;
          font-weight: bolder;
          text-align: right;
        }
        span {
          float: left;
          // height: 40px;
          line-height: 40px;
          margin-left: 10px;
          color: #333333;
          font-size: 14px;
        }
        .fileTxt {
          float: left;
          width: calc(100% - 140px);
          height: 40px;
          line-height: 40px;
          padding: 0 0 0 20px;
          box-sizing: border-box;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 14px;
          img {
            width: 15px;
            height: 15px;
          }
          a {
            color: #00b49b;
            font-size: 14px;
            margin-left: 5px;
          }
          span {
            margin-left: 0;
            font-size: 14px;
          }
        }
      }
    }
    .bzflYljs_row {
      padding: 20px 0 0;
      display: flex;
      .bzflYljs_row_col {
        flex: 1;
      }
    }
    .speedDetails_Filelist {
      border-bottom: 1px solid #ddd;
      margin-bottom: 10px;
    }
    .speedDetails_Filelist:last-child {
      border-bottom: 0;
    }
    .speedDetails_new_file {
      width: 100%;
      min-height: 45px;
      .speedDetails_new_fileItem {
        display: block;
        width: 280px;
        min-height: 40px;
        position: relative;
        line-height: 40px;
        .lable {
          display: block;
          width: 100%;
          min-height: 40px;
          text-align: right;
          span {
            color: #666666;
            font-size: 14px;
            font-weight: bolder;
          }
        }
        .fileTxt {
          position: absolute;
          left: 280px;
          top: 50%;
          // max-width: calc(100% - 500px);
          height: 40px;
          line-height: 40px;
          padding: 0 0 0 20px;
          box-sizing: border-box;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          transform: translateY(-50%);
          img {
            width: 15px;
            height: 15px;
            position: relative;
            top: 3px;
          }
          a {
            color: #00b49b;
            font-size: 14px;
            margin-left: 5px;
          }
        }
        .fileUploadBtn {
          float: left;
          font-size: 13px;
          cursor: pointer;
          margin: 12px 0 0 15px;
        }
      }
      .speedDetails_new_fileItem1 {
        display: block;
        width: 280px;
        position: relative;
        margin: 10px 0;
        padding: 10px 0;
        .lable {
          display: block;
          width: 100%;
          min-height: 40px;
          text-align: right;
          span {
            color: #666666;
            font-size: 14px;
            font-weight: bolder;
            vertical-align: middle;
          }
        }
        .fileTxt {
          position: absolute;
          left: 280px;
          top: 50%;
          height: 40px;
          padding: 0 0 0 20px;
          box-sizing: border-box;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          transform: translateY(-50%);
          img {
            width: 15px;
            height: 15px;
            position: relative;
            top: 3px;
          }
          a {
            color: #00b49b;
            font-size: 14px;
            margin-left: 5px;
          }
        }
        .fileUploadBtn {
          float: left;
          font-size: 13px;
          cursor: pointer;
          margin: 12px 0 0 15px;
        }
      }
    }
  }
  .speedDetails_btn {
    text-align: center;
    padding: 20px 0;
    .ivu-btn {
      border-color: #00b49b;
      color: #00b49b;
      border-color: #00b49b;
    }
  }
}
</style>
<script>
import util from "@/libs/util";
import { UserNew, TeacherNewFile, DeclareListState, Withdraw } from "@/api/declare/index";
import { getTeacherList , resumeQuery} from "@/api/declare1/index";
import { UploadFileList } from "@/api/upload/index";
export default {
  data() {
    return {
      loading: false,
      code: "",
      cur_audit_status: 0,
      submitState: 1,
      cur_audit_org_lv: null,
      identity_type: null,
      userObj: {
        name: "",
        birthday: "",
        studyTime: "",
        edu: "",
        unitName: "",
        archivesCompany: "",
        gender: 0,
        region: "",
        practice: "",
        nation: "",
        academic: "",
        postalAddress:"",
        address: "",
        household: "",
        idCarNum:"",
        unitPostalCode: "",
        PostalCode: "",
        review:""
      },
      zjzFile: {
        file_name: "",
        full_path: ""
      },
      TeacherList: [],
      resumeList:[],
      zgclFileArr: [],
      withdrawId: ""
    };
  },
  created() {
    let code = this.$route.params.code;
    this.code = code;
    this.getUserNew();
    this.getSpeed();
    
  },
  methods: {
    //查询考生信息
    getUserNew() {
      this.loading = true;
      let id = util.storage.getUserInfo().obj_id;
      UserNew(id).then(res => {
        if(res.identity_type ===3){
          this.getZGCLList('sczykh_sccskhsqb,sczykh_scgxhts,sczykh_sfz_1,sczykh_sfz_2,sczykh_xl');
        }else if(res.identity_type ===4){
          this.getZGCLList('sczykh_qyzc_sqb,sczykh_sfz_1,sczykh_sfz_2,sczykh_qyzc_lcsjnxzm');
        }
        this.identity_type = res.identity_type;
        this.userObj.name = res.name;
        this.userObj.birthday = util.tool.dateFormat("yyyy-MM-dd",new Date(res.birth_date));
        this.userObj.studyTime =(util.tool.dateFormat("yyyy-MM-dd",new Date(res.participate_work_start_date))) + " ~ " + (util.tool.dateFormat("yyyy-MM-dd",new Date(res.participate_work_end_date)));
        this.userObj.edu = res.education;
        this.userObj.unitName = res.company_name;
        this.userObj.archivesCompany = res.archives_company;
        this.userObj.gender = res.gender;
        this.userObj.region = res.org_name;
        this.userObj.practice = res.present_occupation;
        this.userObj.nation = res.nation;
        this.userObj.academic = res.academicDegree;
        this.userObj.postalAddress = res.company_address;
        this.userObj.address = res.archives_address;
        this.userObj.household = res.province+res.city;
        this.userObj.idCarNum = res.idcard_no;
        this.userObj.unitPostalCode = res.company_mailbox;
        this.userObj.PostalCode = res.archives_mailbox;
        this.userObj.review = res.expertise_review;
        this.getzyyyzz();
        this.getResumeList(id);
      }).catch(() => {
        this.loading =false;
      });
      
    },
    // 查询个人简历列表
    getResumeList(id){
        resumeQuery(id).then(res=>{
          if(res&&res.length>0){
            let dataArr = new Array();
            for(let i=0;i<res.length;i++){
                let objs = res[i];
                objs.start_date =  util.tool.dateFormat("yyyy-MM-dd",new Date(res[i].start_date));
                objs.end_date =  util.tool.dateFormat("yyyy-MM-dd",new Date(res[i].end_date));
                dataArr.push(objs);
            }
            this.resumeList = dataArr;
          }else {
            this.resumeList = [];
          }
          this.TeacherListNew(id);
        }).catch(() => {
          this.loading =false;
        });
    },
    //查询执业营业执照
    getzyyyzz() {
      let params = {
        obj_id: util.storage.getUserInfo().obj_id,
        type_key: "sczykh_zjz"
      };
      UploadFileList(params).then(res => {
        if (res.length > 0) {
          this.zjzFile = res[0];
        }
      });
    },
    //查询指导老师或者推荐医师列表详情
    TeacherListNew(id) {
      getTeacherList(id,{identity_type: (this.identity_type===3?1:2)}).then(res => {
        this.TeacherList = res;
        this.loading = false;
        for (let i = 0; i < res.length; i++) {
          if (this.identity_type == 3) {
            this.getTeacherFile(res[i].id,"sczykh_yszgz,sczykh_yszyz,sczykh_zyjszwzgz,sczykh_work15zm,sczykh_zdlsdwzm,sczykh_zdlscjxxhgzm",i);
          } else {
            this.getTeacherFile(res[i].id,"sczykh_yszgz,sczykh_yszyz,sczykh_zljszm",i);
          }
        }
      }).catch(() => {
        this.loading =false;
      });
    },
    //查询指导老师或推荐医师对应附件
    getTeacherFile(teacherID, typeKeyArr, index) {
      let params = {
        obj_id: teacherID,
        type_key: typeKeyArr
      };
      TeacherNewFile(params).then(res => {
        this.$set(this.TeacherList[index], "fileList", res);
      });
    },
    //资格材料上传
    getZGCLList(typeKeyArr) {
      let id = util.storage.getUserInfo().obj_id;
      let params = {
        obj_id: id,
        type_key: typeKeyArr
      };
      TeacherNewFile(params).then(res => {
        this.zgclFileArr = res;
      });
    },
    //撤回状态信息
    getSpeed() {
      let params = {
        user_id: util.storage.getUserInfo().obj_id,
        project_code: this.$route.params.code
      };
      DeclareListState(params).then(res => {
        this.withdrawId = res[0].id;
        this.cur_audit_status = res[0].cur_audit_status;
        this.submitState = res[0].submit_status;
        this.cur_audit_org_lv = res[0].cur_audit_org_lv;
      });
    },
    //撤回按钮
    withdraw() {
      this.$Modal.confirm({
        title: "提示信息",
        content: "是否撤销提交的信息?",
        onOk: () => {
          this.loading = true;
          Withdraw(this.withdrawId).then(() => {
            this.loading = false;
            this.$Message.success("撤销成功!");
            this.$router.push({
              name: "speedQuery",
              params: {
                code: this.$route.params.code
              }
            });
          });
        }
      });
    }
  }
};
</script>